import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';

export const shopSplitPaymentEdit = http.put(
  createMockEndpoint('/shop/:id/split_payment'),
  async () => {
    await delay(500);
    return HttpResponse.json(null, { status: 200 });
  },
);
